import FeedWidget from './widget-variants/feed';
// This is a register function for the feed widget
(function () {
    // Register the widget to the window
    window._mensenlinq = window._mensenlinq || {};
    window._mensenlinq.feed = window._mensenlinq.feed || FeedWidget;
    window._mensenlinq.commitHash = '1';
})();
